import { render, staticRenderFns } from "./InsCmsTwoSwiper.vue?vue&type=template&id=7be84654&"
import script from "./InsCmsTwoSwiper.vue?vue&type=script&lang=ts&"
export * from "./InsCmsTwoSwiper.vue?vue&type=script&lang=ts&"
import style0 from "./InsCmsTwoSwiper.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports